import React from "react"
import styled from "styled-components"

import Icon from "~/components/atoms/Icon"
import Typography from "~/components/atoms/Typography"
import { Color, RadiusSize, SpacingSize } from "~/consts/style-mixins"

interface IProps {
  text: string
  url?: string
  onClickClose: () => void
  className?: string
}

const FormListEnteredItem: React.VFC<IProps> = ({ text, url, onClickClose, className }) => (
  <StyledWrapper className={className}>
    <div>
      <Typography type="Description">{text}</Typography>
      {url && <Typography type="Note">{url}</Typography>}
    </div>
    <StyledClose onClick={onClickClose}>
      <Icon size={14} type="Cancel" color={Color.Gray} />
    </StyledClose>
  </StyledWrapper>
)

export default FormListEnteredItem

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${Color.BorderGray};
  border-radius: ${RadiusSize.Medium}px;
  padding: ${SpacingSize.XS}px ${SpacingSize.S}px;
  overflow-wrap: anywhere;
`

const StyledClose = styled.div`
  display: flex;
  align-items: center;
  max-width: 32px;
  cursor: pointer;
  margin-left: ${SpacingSize.XS}px;
`
